export default __webpack_public_path__ + "static/media/favpng_communication-icon-chat-icon-min.66cf952d.png";